/* C32 · qt-float.js — one floating layer. Measures the highest visible bottom bar (QT cart bar,
   Horizon sticky add-to-cart) and sets --qt-float-base, so the gift pop-up / favourites toast /
   chat sit above it, and --qt-cart-bar-height, so the sticky add-to-cart stacks above the cart bar.
   The cart bar button opens Horizon's cart drawer (plain link to /cart without JS). */
import { onScroll } from '@qt/core';

const root = document.documentElement;
const BARS = '[data-qt-cart-bar]:not([hidden]), .sticky-add-to-cart__bar';

function measure() {
  const cartBar = document.querySelector('[data-qt-cart-bar]:not([hidden])');
  root.style.setProperty('--qt-cart-bar-height', `${cartBar ? cartBar.offsetHeight : 0}px`);
  let top = window.innerHeight;
  for (const bar of document.querySelectorAll(BARS)) {
    const rect = bar.getBoundingClientRect();
    const style = getComputedStyle(bar);
    if (rect.height && rect.top < window.innerHeight && style.visibility !== 'hidden' && Number(style.opacity) > 0.1) {
      top = Math.min(top, rect.top);
    }
  }
  root.style.setProperty('--qt-float-base', `${Math.max(0, Math.round(window.innerHeight - top))}px`);
}

let frame = 0;
const schedule = () => {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(measure);
};

onScroll(schedule);
window.addEventListener('resize', schedule);
new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['hidden', 'data-stuck'] });
document.addEventListener('transitionend', schedule);
measure();

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-qt-open-cart]')) return;
  const trigger = document.querySelector('[aria-controls="cart-drawer"]');
  if (!trigger) return;
  event.preventDefault();
  trigger.click();
});
